export default {
  props: {
    img: String,
    title: String,
    desc1: String,
    desc2: String,
    layout: {
      type: String,
      default: 'left'
    }
  }
};